<header class="header">
    <div class="logo">
        <img src="assets/version2/Logo-Horizontal_Color_Dark-1024x302.png" alt="Logo"> <!-- Replace with your logo path -->
    </div>
    <nav class="nav">
        <ul>
            <li><a href="https://iylon.com/about/">About</a></li>
            <li class="dropdown">
                <a href="#">Services <span class="dropdown-icon">&#9662;</span></a>
                <ul class="dropdown-menu">
                    <li><a href="https://iylon.com/how-it-works/">How It Works</a></li>
                    <li><a href="https://iylon.com/faq/">FAQ</a></li>
                </ul>
            </li>
            <li><a href="https://iylon.com/advisors/">Advisors</a></li>
            <li><a href="https://iylon.com/resources/">Resources</a></li>
            <li><a href="https://iylon.com/contact/">Contact</a></li>
        </ul>
    </nav>
</header>